<template>
    <div>
<!--
        <div class="margin-left-15">ERPSKU:<span class="font-weight">{{comperpsku.erpsku}}</span> &nbsp; {{$t('erp.product.stock_total', { defaultValue: '库存总数量' })}}:<span class="font-weight">{{comperpsku.qty}}</span></div>
-->
        <compTablelist class="margin-layout" :columns="columns" v-bind="getCostTableProps"></compTablelist>
    </div>
</template>
<script>
// HttpGetInventoryList
import { HttpSaAccountList } from '@/service/boss/allot';
export default {
    props:['comperpsku'],
    components:{
        compTablelist: () => import("@components/templates/tablelist"),
    },
    data(){
        return {
            // formList:[],
        }
    },
    computed:{
        getCostTableProps() {
			return {
				initFormData:{
                    'search[EQ_accountFlag]': this.comperpsku.accountFlag,
                    'search[EQ_sellerSku]': this.comperpsku.sellerSku,
				},
				startUp:true,
				ajaxRequest: HttpSaAccountList,
                /*interceptResponse: (data,_this) => {
                    let array = [];
                    if(this.typedata == 'listinginventory'){
                        data.content.map(item=>{
                            if(item.warehouseType != 2){
                                array.push(item)
                            }
                        })
                        _this.dataList = array
                    }
				},*/
			};
		},
        columns(){
            return [
                {
                    title: this.$t('global.common.warehouse', { defaultValue: "仓库" }),
                    key:'orgWarehouseCode'
                },
                {
                    title: "店铺",
                    key:'accountFlag'
                },
                {
                    title: "seller sku",
                    key:'sellerSku'
                },
                {
                    title: "总库存",
                    key:'quantity'
                },
                {
                    title: "更新时间",
                    key:'updatedAt'
                },
            ]
        }
    },
}
</script>
